import React, { useEffect, useState, useRef } from "react"
import {
  Box,
  Container,
  Flex,
  Grid,
  Heading,
  Text,
  Image,
} from "@theme-ui/components"
import RichContentStructuredText from "../richContentStructuredText"
import {
  Accordion as AccordionWrapper,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
  AccordionItemState,
} from "react-accessible-accordion"
import { GatsbyImage } from "gatsby-plugin-image"
import AccordionOpened from "../../images/accordion-opened.svg"
import { InboundLink } from "../link"
import { getProductTypePath } from "../../utils/path"
import ArrowBlack from "../../images/Arrow_black.svg"
import { motion, AnimatePresence } from "framer-motion"
import AccordionClosed from "../../images/accordion-closed.inline.svg"
import { useResponsiveValue, useBreakpointIndex } from "@theme-ui/match-media"
import {useIntersection} from "../../utils/useIntersection"

const AnimatedBox = motion(Box)

const ProductTypeCollection = ({ title, items }) => {
  const productTypeCollectionRef = useRef();
  const inViewport = useIntersection(productTypeCollectionRef && productTypeCollectionRef)

  useEffect(()=>{
    const container = document.querySelector(
      ".numbers_insight_container"
    )
    if(container)
    container.style.overflow = "hidden"
    
  },[inViewport])
  

  return (
    <Box
      ref={productTypeCollectionRef}
      className="productTypeCollection"
      mb={[4, 6, 6, 8]}
      sx={{
        backgroundColor: "light",
      }}
    >
      {title && (
        <Container>
          <Heading variant="h2">{title}</Heading>
        </Container>
      )}
      <Box></Box>
      {items.map((item, index) => (
        <ProductType item={item} index={index} />
      ))}
    </Box>
  )
}

const ProductType = ({ item, index }) => {
  const mediaIndex = useBreakpointIndex()
  const [isHover, setIsHover] = useState(false)

  const containerVariant = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.3,
      },
    },
    exit: {
      opacity: 0,
      transition: {
        staggerChildren: 0.3,
      },
    },
  }

  const imageVariant = {
    hidden: {
      opacity: 0,
      transition: {
        duration: 0.5,
      },
    },
    show: {
      opacity: 1,
      transition: {
        duration: 0.5,
      },
    },
    exit: {
      opacity: 0,
      transition: {
        duration: 0.5,
      },
    },
  }

  return (
    <Box
      sx={{
        borderTop: "1px solid",
        borderColor: "lightGrey",
      }}
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
    >
      <Box
        sx={{
          cursor: "pointer",
          "&:hover": {
            backgroundColor: "light",
          },
          a: {
            color: "dark",
            textDecoration: "none",
          },
        }}
      >
        {/* {console.log("getProductTypePath",item)} */}
        <InboundLink to={getProductTypePath(item, item.locale)}>
          <Container sx={{ position: "relative", overflow: "hidden" }}>
            <Flex
              sx={{
                justifyContent: "space-between",
                alignItems: "center",
                minHeight: "80px",
              }}
            >
              <Flex sx={{ alignItems: "center" }}>
                <Box
                  sx={{
                    minWidth: "24px",
                    // flexGrow: 1,
                    mr: [2, 3, 4, 4],
                  }}
                >
                  <Text
                    sx={{
                      color: "primary",
                    }}
                  >
                    0{index + 1}.
                  </Text>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <Text
                    className={isHover && "active-hover"}
                    sx={{
                      fontSize: [3, 5, 6, 7],
                      mt: 0,
                      textTransform: "uppercase",
                      lineHeight: 1.2,
                      transition: "all .3s ease-in-out",
                      svg: {
                        display: "none",
                      },
                      "&.active-hover": {
                        fontSize: [2, 4, 5, 6],
                        transition: "all .3s ease-in-out",
                        textDecoration: "none",
                        color: "primary",
                      },
                    }}
                  >
                    {item.title}
                  </Text>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      height: "100%",
                      ml: [2],
                      transition: "all .2s ease",
                      maxWidth: ["50%", "75%", "75%", "100%"],
                      mt: [1],
                      svg: {
                        width: "auto",
                        height: ["12px", "24px"],
                        transform: "rotate(45deg)",
                        opacity: isHover ? "1" : "0",
                        transition: "all .2s ease .2s",
                        fill: "primary",
                      },
                    }}
                  >
                    <AccordionClosed />
                  </Box>
                </Box>
              </Flex>
            </Flex>
            <Box sx={{ display: ["none", "block"] }}>
              <AnimatePresence>
                {isHover && (
                  <motion.div
                    variants={containerVariant}
                    initial="hidden"
                    animate="show"
                    exit={{ opacity: 0 }}
                    style={{
                      position: "absolute",
                      top: 0,
                      right: "0",
                      display: "flex",
                      width: "100%",
                      height: "100%",
                      alignItems: "center",
                      justifyContent: "flex-end",
                    }}
                  >
                    {item.images.length > 0 &&
                      item.images.map(image => (
                        <motion.div
                          variants={imageVariant}
                          style={{
                            height: "100%",
                            position: "relative",
                            width: mediaIndex >= 2 ? "33%" : "25%",
                          }}
                        >
                          <AnimatedBox
                            sx={{
                              position: "absolute",
                              top: "-50%",
                              left: 0,
                              height: "100%",
                              width: "100%",
                              transform: "translateY(-50%)",
                              ".gatsby-image-wrapper": {
                                overflow: "visible!important",
                                height: "auto",
                                py: ["1px"],
                                maxWidth: ["400px", "642px"],
                                width: "100%",
                              },
                            }}
                            initial={{ scale: 1.15 }}
                            animate={{ scale: 0.5, y: "25%" }}
                            transition={{
                              duration: 6,
                            }}
                          >
                            <GatsbyImage image={image.gatsbyImageData} alt="" />
                          </AnimatedBox>
                        </motion.div>
                      ))}
                  </motion.div>
                )}
              </AnimatePresence>
            </Box>
          </Container>
        </InboundLink>
      </Box>
    </Box>
  )
}

export default ProductTypeCollection
